var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('v-img',{staticClass:"shrink mx-2",attrs:{"alt":"Logo","contain":"","src":"/images/logo.png","transition":_vm.transition,"width":_vm.width,"height":_vm.height}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }